import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
  Badge,
  Input,
  FormGroup,
  Button,
} from "reactstrap";
import DataTable from "react-data-table-component";
import { Triangle } from "react-loader-spinner";
import toast from "react-hot-toast";
import PurchaseServices from "../../Services/QRCodeServices/PurchaseServices/PurchaseServices";
import NumberCommas from "../../Components/NumberCommas/NumberCommas";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { Link } from "react-router-dom";
import { formatDate } from "../../Components/FormatDate/FormatDate";
import DeleteModal from "../../Components/Common/DeleteModal";

function Purchase() {
  const [billsList, setBillsList] = useState([]);
  const [filteredBills, setFilteredBills] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [deleteModal, setDeleteModal] = useState(false); // Added state for delete modal
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null); // Added state for selected item

  const toggleDeleteModal = () => setDeleteModal(!deleteModal); // Added toggle function

  const customStyles = {
    headCells: {
      style: {
        fontSize: "0.92rem",
        fontWeight: 610,
      },
    },
    rows: {
      style: {
        fontSize: "0.9rem",
      },
    },
  };

  const columns = [
    {
      name: "S.N",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "80px",
    },
    {
      name: "Date",
      selector: (row) => formatDate(row.valueData),
      sortable: true,
    },
    {
      name: "Invoice No.",
      selector: (row) => row.invoiceNumber,
      sortable: true,
    },
    {
      name: "Total Amount",
      selector: (row) => <NumberCommas number={row.netAmt}/>,
      sortable: true,
      right: true,
      width: "150px",
  
    },
    {
      name: "Actions",
      center: true,
      cell: (row) => (
        <div className="hstack gap-2">
          <Link to={`/purchases/details/${row.id}`}>
            <Button color="btn btn-soft-success" className="btn-sm gap-1">
              <i className="bx bx-show" />
            </Button>
          </Link>
          <Link to={`/purchases/edit/${row.id}`}>
            <Button color="btn btn-soft-warning" className="btn-sm gap-1">
              <i className="ri-edit-line"></i>
            </Button>
          </Link>
          <Button
            color="btn btn-soft-danger"
            size="sm"
            onClick={() => handleDeleteClick(row)}
          >
            <i className="ri-delete-bin-line"></i>
          </Button>
        </div>
      ),
    },
  ];

  async function fetchPurchaseBills() {
    try {
      setLoading(true);
      const fetchedBills = await PurchaseServices.getList();
      setBillsList(fetchedBills);
      setFilteredBills(fetchedBills);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching purchase bills:", err);
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchPurchaseBills();
  }, []);

  const handleItemNameClick = (row) => {
    // Handle item name click if needed
  };

  // Added delete handlers
  const handleDeleteClick = (item) => {
    setSelectedDeleteItem(item);
    toggleDeleteModal();
  };

  const handleDelete = async () => {
    if (selectedDeleteItem) {
      try {
        await PurchaseServices.delete(selectedDeleteItem.id); // Assuming PurchaseServices has a delete method
        toast.success("Purchase bill deleted successfully");
        fetchPurchaseBills();
      } catch (error) {
        toast.error("Failed to delete purchase bill");
      } finally {
        toggleDeleteModal();
        setSelectedDeleteItem(null);
      }
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Purchase Bills List" pageTitle="Purchases Bills" />
          <div className="mb-3 text-end">
            <Link to="/purchases/create">
              <Button color="soft-success">+ New Purchase</Button>
            </Link>
          </div>
          <Row>
            <Col>
              <Card>
                <CardHeader></CardHeader>
                <CardBody>
                  <DataTable
                    columns={columns}
                    data={filteredBills}
                    customStyles={customStyles}
                    responsive
                    striped
                    highlightOnHover
                    pagination
                    paginationPerPage={10}
                    paginationRowsPerPageOptions={[10, 25, 50, 100]}
                    progressPending={loading}
                    progressComponent={
                      <div className="my-3">
                        <Triangle
                          visible={true}
                          height="80"
                          width="80"
                          color="#5B71B9"
                          ariaLabel="triangle-loading"
                        />
                        <h5 className="mt-1">Loading...</h5>
                      </div>
                    }
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDelete}
        onCloseClick={toggleDeleteModal}
        selectedItem={selectedDeleteItem}
      />
    </React.Fragment>
  );
}

export default Purchase;